module.exports = __webpack_public_path__ + "static/media/comment - Copy.5f733470.jpg";